import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Mail, AlertCircle, Loader2, FileCheck, ArrowLeft, CheckCircle2, Send } from "lucide-react";

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [devLink, setDevLink] = useState("");

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await axios.post(`${API_URL}/api/auth/forgot-password`, { email });
      setSent(true);
      if (data.dev_reset_link) setDevLink(data.dev_reset_link);
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="auth-page" data-testid="forgot-password-page">
      <div className="auth-card">
        <div className="auth-header">
          <Link to="/" className="auth-logo-link">
            <div className="lp-logo-icon"><FileCheck size={16} /></div>
            <span className="auth-logo">ResumeAI</span>
          </Link>
          <h1>{sent ? "Check your email" : "Forgot password?"}</h1>
          <p>{sent ? "If an account exists for that email, we've sent a reset link." : "Enter your email and we'll send you a reset link."}</p>
        </div>

        {error && (
          <div className="auth-error" data-testid="forgot-error">
            <AlertCircle size={16} />
            <span>{error}</span>
          </div>
        )}

        {sent ? (
          <div className="auth-form" data-testid="forgot-success">
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 12, padding: "8px 0 4px" }}>
              <CheckCircle2 size={40} style={{ color: "#10b981" }} />
              <p style={{ textAlign: "center", color: "var(--text-secondary)", fontSize: "0.9rem", margin: 0 }}>
                Open the link in your inbox to choose a new password. The link expires in 60 minutes.
              </p>
            </div>
            {devLink && (
              <a href={devLink} className="auth-btn" data-testid="dev-reset-link" style={{ textDecoration: "none" }}>
                <Send size={16} /> Open reset link (dev)
              </a>
            )}
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="auth-form">
            <div className="auth-field">
              <label htmlFor="email">Email</label>
              <div className="auth-input-wrap">
                <Mail size={16} className="auth-input-icon" />
                <input
                  id="email"
                  type="email"
                  placeholder="you@gmail.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  data-testid="forgot-email"
                />
              </div>
            </div>
            <button type="submit" className="auth-btn" disabled={loading} data-testid="forgot-submit">
              {loading ? <Loader2 size={18} className="spin" /> : <Send size={18} />}
              {loading ? "Sending..." : "Send reset link"}
            </button>
          </form>
        )}

        <div className="auth-footer">
          <Link to="/login" data-testid="back-to-login" style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
            <ArrowLeft size={14} /> Back to sign in
          </Link>
        </div>
      </div>
    </div>
  );
}
